var _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32, _defs33, _defs34, _defs35, _defs36, _defs37, _defs38, _defs39, _defs40, _defs41, _defs42, _defs43, _defs44, _defs45, _defs46;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMoneySaving = function SvgMoneySaving(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__a",
    d: "M300.3 171.2c15.9 55.4-16.1 113.2-71.5 129.1-55.4 15.9-113.2-16.1-129.1-71.5s16.1-113.2 71.5-129.1c55.4-15.9 113.2 16.1 129.1 71.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#MoneySaving_svg__b)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__c",
    d: "M-259.3-550.9h2460.6V611.7H-259.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__c",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.997 200.032 200.023)",
    style: {
      clipPath: "url(#MoneySaving_svg__d)",
      fill: "#fcb618"
    },
    d: "M85.4 85.4h229.2v229.2H85.4z"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__e",
    d: "M288.8 190.6c-.2.3-.4.5-.7.7l-7 4-2.3 12.8c-.1.4-.3.7-.6 1-.3.3-.6.4-1 .5-.4 0-.8 0-1.1-.3-.4-.2-.6-.5-.8-.9l-4.6-12.2-7.6-2.6c-.3-.1-.6-.3-.8-.6-.2-.3-.3-.6-.4-.9 0-.4 0-.7.2-1 .1-.3.4-.5.7-.7l7-4 2.3-12.8c.1-.4.3-.7.6-1 .3-.3.7-.4 1.1-.5.4 0 .8.1 1.1.3.3.2.6.5.7.9l4.6 12.2 7.6 2.6c.3.1.6.3.8.6.2.3.3.6.3 1 .1.3 0 .6-.1.9zm-10.6-2c-.6-.2-.9-.6-1.1-1.1l-2.5-6.8-1.3 7.2c-.1.6-.4 1-.9 1.3l-4.2 2.4 4.6 1.6c.6.2.9.6 1.1 1.1l2.6 6.8 1.3-7.2c.1-.5.4-.9.9-1.3l4.2-2.4-4.7-1.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__e",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#MoneySaving_svg__f)"
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__g",
    d: "M-259.3-550.9h2460.6V611.7H-259.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__h"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__g",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.997 275.538 190.924)",
    style: {
      clipPath: "url(#MoneySaving_svg__h)",
      fill: "#5c0425"
    },
    d: "M251.9 162.2h47.2v57.4h-47.2z"
  })), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__i",
    d: "M117.5 238.8c-.2-.3-.2-.7-.2-1 0-.3.2-.6.4-.9l5.1-6.2-2.6-12.7c-.1-.4 0-.8.2-1.1.2-.4.4-.6.8-.8.4-.2.7-.2 1.2-.2.4.1.7.2 1 .5l8.7 9.7 8-.3c.4 0 .7.1 1 .2.3.2.5.4.7.8.2.3.2.6.2 1s-.2.6-.4.9l-5 6.2 2.6 12.7c.1.4 0 .8-.2 1.1-.2.4-.5.6-.8.8-.4.2-.7.2-1.1.2-.4-.1-.7-.3-1-.5l-8.7-9.7-8 .3c-.3 0-.6-.1-.9-.2-.6-.3-.8-.5-1-.8zm5.6-2.8 4.8-.2c.6 0 1.1.2 1.4.6l4.9 5.4-1.4-7.2c-.1-.5 0-1 .4-1.5l3-3.7-4.8.2c-.6 0-1.1-.2-1.4-.6l-4.9-5.4 1.4 7.1c.1.5 0 1-.4 1.5l-3 3.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__j"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__i",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#MoneySaving_svg__j)"
    }
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__k",
    d: "M-259.3-550.9h2460.6V611.7H-259.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__l"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__k",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.997 129.661 232.758)",
    style: {
      clipPath: "url(#MoneySaving_svg__l)",
      fill: "#5c0425"
    },
    d: "M106.1 204h47.2v57.4h-47.2z"
  })), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__m",
    d: "m114.7 199.3.8-6.8 12.5-1.7v-.1l-11.7-5.2.8-6.8 18.1 2.7-.5 4.3-13.8-2.1v.2l11.7 5.7-.4 3.9-12.7 2.1v.2l13.8 2-.5 4.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__n"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__m",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#MoneySaving_svg__n)"
    }
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__o",
    d: "M-259.3-550.9h2460.6V611.7H-259.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__p"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__o",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.997 124.972 190.367)",
    style: {
      clipPath: "url(#MoneySaving_svg__p)",
      fill: "#5c0425"
    },
    d: "M102.4 166.8h45.1V214h-45.1z"
  })), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__q",
    d: "M140.6 172.1c-2.4 5.5-8.2 7.8-13.4 5.6-5.2-2.2-7.3-8-4.8-13.4 2.4-5.4 8.1-7.8 13.3-5.6 5.2 2.2 7.2 8 4.8 13.4h.1zm-6.8-9c-3.1-1.3-6.3-.2-7.6 2.9-1.4 3.1-.1 6.1 3 7.5 3.1 1.3 6.3.2 7.6-2.9 1.3-3.1.1-6.2-3-7.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__r"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__q",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#MoneySaving_svg__r)"
    }
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__s",
    d: "M-259.3-550.9h2460.6V611.7H-259.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__t"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__s",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.997 131.43 168.248)",
    style: {
      clipPath: "url(#MoneySaving_svg__t)",
      fill: "#5c0425"
    },
    d: "M110.9 147.7h41v41h-41z"
  })), _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__u",
    d: "m129.2 153.1 2.7-3.3 14.8 1.2-9.6-7.6 2.6-3.1 14.7 11.5-2.7 3.3-14.7-1.2h-.1l9.6 7.6-2.5 3.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__v"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__u",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#MoneySaving_svg__v)"
    }
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__w",
    d: "M-259.3-550.9h2460.6V611.7H-259.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__x"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__w",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.997 141.837 152.463)",
    style: {
      clipPath: "url(#MoneySaving_svg__x)",
      fill: "#5c0425"
    },
    d: "M119.3 129.9h45.1V175h-45.1z"
  })), _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__y",
    d: "m147.2 135.8 2.1 2.4 5.7-4.3 2.4 2.8-5.7 4.3 2.4 2.8 5.8-4.4 2.4 2.8-9.3 7-11.7-13.5 9.3-7.1 2.4 2.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__z"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__y",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#MoneySaving_svg__z)"
    }
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__A",
    d: "M-259.3-550.9h2460.6V611.7H-259.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__B"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__A",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.997 151.823 138.931)",
    style: {
      clipPath: "url(#MoneySaving_svg__B)",
      fill: "#5c0425"
    },
    d: "M132.3 118.4h39v41h-39z"
  })), _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__C",
    d: "m165.8 134.7-12-7.5 4.7-2.4 7.3 5h.1l-.1-8.8 4.7-2.4-.5 14 3 5.7-4.1 2.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__D"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__C",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#MoneySaving_svg__D)"
    }
  }, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__E",
    d: "M-259.3-550.9h2460.6V611.7H-259.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__F"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__E",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.997 164.492 131.032)",
    style: {
      clipPath: "url(#MoneySaving_svg__F)",
      fill: "#5c0425"
    },
    d: "M145 110.5h39v41h-39z"
  })), _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__G",
    d: "M189.2 132.5c-5.4.9-9.1-1.7-9.9-5.8l4.7-.8c.5 2.4 2.3 3.5 4.7 3.1 2-.3 3.1-1.4 2.9-2.9-.2-1.4-1.3-1.5-2.3-1.5l-3.6.1c-3.3.1-5.2-1.2-5.7-3.9-.5-3.3 1.6-5.7 5.6-6.4 4-.6 6.9.9 7.7 4l-4.4.8c-.5-1.2-1.5-1.7-2.9-1.5-1.4.2-2.1 1-2 2 .1.9.8 1.2 2.2 1.2l3.3-.1c3.6-.1 5.8 1.3 6.3 4.3.6 3.6-1.9 6.5-6.6 7.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__H"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__G",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#MoneySaving_svg__H)"
    }
  }, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__I",
    d: "M-259.3-550.9h2460.6V611.7H-259.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__J"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__I",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.997 186.877 123.544)",
    style: {
      clipPath: "url(#MoneySaving_svg__J)",
      fill: "#5c0425"
    },
    d: "M168.4 104.1h36.9v39h-36.9z"
  })), _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__K",
    d: "m210.6 126.4-7.3-.6-2.9 5.8-4.9-.4 9.7-18.3 6 .5 6.1 19.5-4.9-.4-1.8-6.1zm-2.9-9.7c-.5 1-1 2.2-1.4 3l-1.3 2.6 4.5.4-.8-2.8c-.2-.9-.5-2.2-.8-3.2h-.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__L"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__K",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#MoneySaving_svg__L)"
    }
  }, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__M",
    d: "M-259.3-550.9h2460.6V611.7H-259.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__N"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__M",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.997 204.344 124.936)",
    style: {
      clipPath: "url(#MoneySaving_svg__N)",
      fill: "#5c0425"
    },
    d: "M183.8 103.4h41v43.1h-41z"
  })), _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__O",
    d: "m237.3 120.9-11.6 16-5.7-1.8-.2-20 4.6 1.5-.3 15.2.1.1 8.5-12.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__P"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__O",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#MoneySaving_svg__P)"
    }
  }, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__Q",
    d: "M-259.3-550.9h2460.6V611.7H-259.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__R"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__Q",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.997 227.729 124.633)",
    style: {
      clipPath: "url(#MoneySaving_svg__R)",
      fill: "#5c0425"
    },
    d: "M207.2 103.1h41v43.1h-41z"
  })), _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__S",
    d: "m238.6 122.6 4 1.9-8.9 16.5-4-1.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__T"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__S",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#MoneySaving_svg__T)"
    }
  }, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__U",
    d: "M-259.3-550.9h2460.6V611.7H-259.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__V"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__U",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.997 236.186 131.808)",
    style: {
      clipPath: "url(#MoneySaving_svg__V)",
      fill: "#5c0425"
    },
    d: "M217.7 113.3h36.9v36.9h-36.9z"
  })), _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__W",
    d: "m245.9 126.9 3.3 2.5-.8 14.8h.1l7.2-9.8 3.2 2.5-11.1 15-3.3-2.6.8-14.7h-.1l-7.2 9.8-3.2-2.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__X"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__W",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#MoneySaving_svg__X)"
    }
  }, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__Y",
    d: "M-259.3-550.9h2460.6V611.7H-259.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__Z"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__Y",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.997 246.895 139.402)",
    style: {
      clipPath: "url(#MoneySaving_svg__Z)",
      fill: "#5c0425"
    },
    d: "M224.3 116.8h45.1v45.1h-45.1z"
  })), _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__aa",
    d: "M267.7 159.6c-4.6 4.6-10.5 4.2-14.4-1.1-3.6-4.8-3.2-10.7.9-14 4.2-3.4 9.7-2.4 13.3 2.4 2.6 3.6 3.2 7.9 1.2 11.1l-2.9-3.9c.4-1.5 0-3.2-1.1-4.8-2-2.7-5-3.1-7.6-1-2.5 2.1-2.8 5.2-.7 8.1 1.7 2.3 4 3 6.2 1.8l-3.2-4.3 2.5-2.1 5.8 7.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__ab"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__aa",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#MoneySaving_svg__ab)"
    }
  }, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__ac",
    d: "M-259.3-550.9h2460.6V611.7H-259.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__ad"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__ac",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.997 260.29 152.629)",
    style: {
      clipPath: "url(#MoneySaving_svg__ad)",
      fill: "#5c0425"
    },
    d: "M240.8 132.1h39v41h-39z"
  })), _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__ae",
    d: "m156.6 252.7 5.6 3.4-3.4 12 9.2-8.5 5.5 3.3-9.4 15.4-3.5-2.1 7.2-11.7-.2-.1-9.5 8.4-3.2-1.9 3.1-12.4h-.1l-7.2 11.7-3.5-2.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__af"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__ae",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#MoneySaving_svg__af)"
    }
  }, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__ag",
    d: "M-259.3-550.9h2460.6V611.7H-259.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__ah"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__ag",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.997 160.398 265.545)",
    style: {
      clipPath: "url(#MoneySaving_svg__ah)",
      fill: "#5c0425"
    },
    d: "M136.8 241.9H184v47.2h-47.2z"
  })), _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__ai",
    d: "m182.7 279-6.6-1.8-3.6 5-4.5-1.2 11.8-15.7 5.5 1.5 2.6 19.7-4.4-1.2-.8-6.3zm-1.1-9.7c-.6.9-1.2 1.9-1.8 2.6l-1.6 2.3 4.1 1.1-.3-2.8c-.1-.9-.2-2.1-.2-3.2h-.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__aj"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__ai",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#MoneySaving_svg__aj)"
    }
  }, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__ak",
    d: "M-259.3-550.9h2460.6V611.7H-259.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__al"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__ak",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.997 177.734 277.641)",
    style: {
      clipPath: "url(#MoneySaving_svg__al)",
      fill: "#5c0425"
    },
    d: "M157.2 256.1h41v43.1h-41z"
  })), _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__am",
    d: "M197.6 268.6c5.8.2 9.8 4.1 9.7 9.7 0 5.6-4.1 9.3-9.9 9.1l-6.3-.2.1-18.8 6.4.2zm5.1 9.6c0-3.2-2.2-5.5-5.2-5.6l-1.9-.1-.1 10.9 1.9.1c3.1.1 5.3-2.1 5.3-5.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__an"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__am",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#MoneySaving_svg__an)"
    }
  }, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__ao",
    d: "M-259.3-550.9h2460.6V611.7H-259.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__ap"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__ao",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.997 197.875 277.2)",
    style: {
      clipPath: "url(#MoneySaving_svg__ap)",
      fill: "#5c0425"
    },
    d: "M178.4 256.7h39v41h-39z"
  })), _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__aq",
    d: "m213.1 270.5.6 3.1 6.5-1.3.7 3.6-6.5 1.2.7 3.6 6.6-1.3.7 3.5-10.6 2.1-3.3-17.3 10.6-2 .7 3.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__ar"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__aq",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#MoneySaving_svg__ar)"
    }
  }, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__as",
    d: "M-259.3-550.9h2460.6V611.7H-259.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__at"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__as",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.997 215.479 275.35)",
    style: {
      clipPath: "url(#MoneySaving_svg__at)",
      fill: "#5c0425"
    },
    d: "M199 255.8h32.8v39H199z"
  })), _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__au",
    d: "m232.2 264 1.4 3.1 6.2-3.1 1.7 3.4-6.2 3.1 1.7 3.5 6.3-3.1 1.7 3.4-10.1 5-8.2-16.8 10.1-5 1.7 3.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__av"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__au",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#MoneySaving_svg__av)"
    }
  }, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__aw",
    d: "M-259.3-550.9h2460.6V611.7H-259.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__ax"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__aw",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.997 235.895 268.43)",
    style: {
      clipPath: "url(#MoneySaving_svg__ax)",
      fill: "#5c0425"
    },
    d: "M218.4 247.9h34.9v41h-34.9z"
  })), _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__ay",
    d: "m254.8 260-5.8 4.5 1.9 6.1-3.9 3-5.7-19.5 4.8-3.7 18.3 9.7-3.9 3-5.7-3.1zm-8.9-4.8c.4 1 .8 2.2 1.1 3.1l.9 2.7 3.6-2.8-2.6-1.4c-.8-.5-1.9-1.2-2.9-1.7l-.1.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__az"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__ay",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#MoneySaving_svg__az)"
    }
  }, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__aA",
    d: "M-259.3-550.9h2460.6V611.7H-259.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__aB"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__aA",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.997 253.775 260.102)",
    style: {
      clipPath: "url(#MoneySaving_svg__aB)",
      fill: "#5c0425"
    },
    d: "M233.2 238.5h41v43.1h-41z"
  })), _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__aC",
    d: "M269 252.4c-3.4 4.4-7.9 5.1-11.3 2.6l2.9-3.8c2 1.4 4 1 5.6-1.1 1.3-1.6 1.3-3.2.2-4.1-1.1-.8-2-.2-2.8.5l-2.6 2.6c-2.4 2.4-4.7 2.8-6.8 1.1-2.6-2-2.8-5.3-.2-8.6 2.5-3.2 5.7-4.2 8.4-2.5l-2.7 3.6c-1.1-.5-2.3-.2-3.1.9-.9 1.1-.9 2.2-.1 2.8.7.5 1.4.3 2.4-.7l2.3-2.4c2.6-2.6 5.2-3.1 7.6-1.2 2.9 2.5 3 6.4.2 10.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__aD"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__aC",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#MoneySaving_svg__aD)"
    }
  }, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__aE",
    d: "M-259.3-550.9h2460.6V611.7H-259.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__aF"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__aE",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.997 261.79 247.136)",
    style: {
      clipPath: "url(#MoneySaving_svg__aF)",
      fill: "#5c0425"
    },
    d: "M242.3 227.6h39v39h-39z"
  })), _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__aG",
    d: "m271.3 236.8-13.4.7 2.1-4.5h8.4v-.1l-5.2-6.9 2-4.4 7.9 11.2 5.6 2.8-1.8 4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__aH"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__aG",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#MoneySaving_svg__aH)"
    }
  }, _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__aI",
    d: "M-259.3-550.9h2460.6V611.7H-259.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__aJ"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__aI",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.997 266.986 231.778)",
    style: {
      clipPath: "url(#MoneySaving_svg__aJ)",
      fill: "#5c0425"
    },
    d: "M246.4 211.2h41v41h-41z"
  })), _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__aK",
    d: "M163.3 193.2c.7-5.5 2-10.1 3.8-13.7 1.9-3.6 3.5-5.6 5-6 1.2-.3 2 .1 2.6 1.3.3.7.8 1.4 1.4 2.3.6.9 1.3 1.6 1.8 2.2-.2-1.2-.1-2.8.3-4.8.3-2 1.1-4.4 2.3-7.1 1.8-4.1 4.5-7.6 8-10.6 3.5-2.9 7.9-5.2 13.1-6.6 5.1-1.5 8-.9 8.8 1.7.1.3.1.7.1 1 0 .3-.1.8-.2 1.4-.2 1.2-.3 2.4-.4 3.6 0 1.2.1 2.9.4 5.1.3 2.2.9 4.8 1.8 8 .4 1.3.8 2.5 1.3 3.5.6-1.9 1.7-3.6 3.4-5.3 1.7-1.7 4-3 7.1-3.8 1.2-.4 2.4-.4 3.6-.2 1.2.2 1.9.9 2.3 2 .1.5.2 1.4.2 2.6 0 1.8.1 3.3.5 4.6.4 1.3.9 2.7 1.7 3.9.7 1.3 1.7 2.9 3 4.7 1.6 2.5 3 4.7 4 6.6 1 1.9 1.9 4 2.6 6.4 1.8 6.4 1.9 12.5.1 18.2-1.8 5.7-5.1 10.7-9.8 14.9-4.8 4.2-10.6 7.2-17.5 9.2-7.2 2.1-14.1 2.3-20.9.9-6.7-1.5-12.7-4.7-17.8-9.6-5.1-4.9-8.8-11.3-11-19.1-1.8-6-2.3-11.8-1.6-17.3m16.2 32.7c4.4 4.3 9.5 7 15.4 8.2-2.3-1.8-4.4-4-6.1-6.5-1.7-2.6-3-5.4-3.9-8.4-1.3-4.6-1.7-9.4-1.2-14.3s1.8-9.6 3.8-14c2-4.4 4.5-8.3 7.4-11.7.3-.4.8-.6 1.2-.8.6-.2 1.3-.1 1.8.3.6.4 1 1 1.2 1.9.6 2.2 1.7 5.1 3.2 8.8 1.5 3.7 3.1 6.9 4.8 9.6 1.7 2.7 3 3.9 4.2 3.6.3-.1.6-.3.7-.7.1-.4.1-.8 0-1.3-.3-1.2-.8-2.3-1.2-3.2-.5-.9-1-1.8-1.7-2.8-.3-.4-.5-.8-.8-1.2-.2-.4-.4-.8-.5-1.1-.2-.6-.1-1.1.1-1.5.2-.4.6-.7 1.1-.9.3-.1.5-.1.8-.1.3 0 .7.1 1.4.2 3.5.8 6.5 1.8 9 2.9 2.5 1.1 4.7 2.6 6.7 4.7s3.5 4.9 4.4 8.3c.9 3.1 1.3 6.1 1.1 9-.1 2.9-.8 5.6-1.8 8.2 3.3-3.4 5.4-7.3 6.5-11.7 1.1-4.4.9-9.1-.5-14-.5-1.8-1.2-3.5-2.1-5-.9-1.5-2-3.4-3.5-5.7-1.4-2.2-2.6-4.1-3.5-5.7-.9-1.6-1.6-3.4-2.1-5.2-.4-1.3-.6-2.9-.8-5.1-1.4.5-2.5 1.2-3.4 2.1-.9.9-1.6 1.9-2 2.8-.5 1-1 2.2-1.5 3.6-.4 1.3-.9 2.3-1.2 3-.4.7-.9 1.1-1.5 1.3-1.6.5-3.1-.2-4.3-2.1-1.3-1.9-2.5-4.9-3.7-9.1-1.9-6.6-2.7-12.4-2.5-17.5l-1.5.4c-4.6 1.2-8.3 3-11.2 5.4-2.9 2.4-5.1 5.4-6.6 8.9-.7 1.5-1.1 2.9-1.4 4.3-.3 1.4-.6 2.9-.8 4.7-.2 1.5-.4 2.6-.6 3.4-.2.8-.5 1.4-.9 2-.4.6-1.1 1-1.9 1.2-1.2.3-2.4.1-3.6-.6-1.2-.8-2.4-1.9-3.5-3.4-2 3.2-3.4 7.1-4.1 11.9-.7 4.8-.2 10.1 1.5 15.8 2 7.2 5.2 12.9 9.6 17.1m15.4 1.1c2.2 2.6 4.8 4.4 8 5.4 3.1 1 6.5 1 10.1 0 3.7-1.1 6.7-2.9 9.1-5.4 2.4-2.5 4-5.5 4.7-8.9.7-3.4.6-7-.5-10.6-.8-2.9-2-5.1-3.6-6.6-1.6-1.6-3.7-2.8-6.4-3.7.3.7.5 1.4.8 2.2.4 1.3.4 2.5.2 3.7-.2 1.2-.7 2.2-1.4 3-.7.8-1.6 1.4-2.7 1.7-2.4.7-4.8-.1-7.1-2.4s-4.3-5.1-6.1-8.5c-1.7-3.4-3.1-6.7-4.2-9.9-3.1 4.6-5.2 9.6-6.3 15-1.1 5.4-.9 10.7.5 15.9 1.1 3.4 2.7 6.5 4.9 9.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__aL"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__aK",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#MoneySaving_svg__aL)"
    }
  }, _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MoneySaving_svg__aM",
    d: "M-259.3-550.9h2460.6V611.7H-259.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "MoneySaving_svg__aN"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MoneySaving_svg__aM",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.997 201.317 196.208)",
    style: {
      clipPath: "url(#MoneySaving_svg__aN)",
      fill: "#5c0425"
    },
    d: "M152.1 141.8h98.4v108.7h-98.4z"
  })));
};

export default SvgMoneySaving;